var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-top"
  }, [_c('van-swipe', {
    staticClass: "myindexswipe",
    attrs: {
      "autoplay": 3000,
      "indicator-color": "white"
    }
  }, _vm._l(_vm.listindex, function (item, index) {
    return _c('van-swipe-item', {
      key: index + '9',
      staticClass: "van-swipe-items"
    }, [_c('div', [index != 0 ? _c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }) : _vm._e(), _c('div', {
      staticClass: "vanvideofont"
    }, [item.serviceTitle ? _c('p', [_vm._v(_vm._s(item.serviceTitle))]) : _vm._e(), item.serviceTitlesw ? _c('p', {
      staticClass: "vanvideofontp"
    }, [_vm._v(_vm._s(item.serviceTitlesw))]) : _vm._e(), item.serviceTitleswz ? _c('div', {
      staticClass: "vanvideofontpbtn",
      on: {
        "click": _vm.rout
      }
    }, [_vm._v(_vm._s(item.serviceTitleswz))]) : _vm._e()])])]);
  }), 1)], 1), _vm.show == true ? [_c('van-overlay', {
    attrs: {
      "show": _vm.show
    },
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "wrapper",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return (() => {}).apply(null, arguments);
      }
    }
  }, [_c('video', {
    staticClass: "banner-video",
    attrs: {
      "poster": require("../../../assets/mobileimg/video-background.png"),
      "controls": "",
      "src": _vm.videos,
      "type": "video/mp4"
    },
    domProps: {
      "muted": false
    }
  }), _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  })])])] : _vm._e(), _c('div', {
    staticClass: "centent"
  }, [_c('p', {
    staticClass: "servertit"
  }, [_vm._v("服务领域")]), _vm._m(0), _c('div', {
    staticClass: "swiper",
    attrs: {
      "id": "swiper1"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      key: index + '8',
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "items",
      on: {
        "click": function ($event) {
          return _vm.routanck(index);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _c('p', [_vm._v(_vm._s(item.serviceTitle))]), _c('div', [_vm._v(" " + _vm._s(item.serviceContent) + " ")])])]);
  }), 0)]), _c('div', {
    staticClass: "swiper-pagination"
  })]), _c('div', {
    staticClass: "centent1"
  }, [_c('p', {
    staticClass: "servertit"
  }, [_vm._v("专业的IDC服务")]), _vm._m(1), _c('van-swipe', {
    staticClass: "IDC-swipe",
    attrs: {
      "autoplay": 3000,
      "indicator-color": "white"
    }
  }, _vm._l(_vm.swipew, function (item, index) {
    return _c('van-swipe-item', {
      key: index + '10',
      on: {
        "click": function ($event) {
          return _vm.goRoute(item);
        }
      }
    }, [_c('div', {
      staticClass: "box-item"
    }, [_c('div', {
      staticClass: "item1"
    }, [_c('img', {
      attrs: {
        "src": _vm.indeximg[index].img,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "item2"
    }, [_c('div', {
      staticClass: "itemtit"
    }, [_c('div', [_vm._v(_vm._s(item.idcTitle) + " "), _c('hr', {
      staticClass: "blue"
    })]), _c('div', {
      staticClass: "itemdeail"
    }, [_c('van-icon', {
      attrs: {
        "name": "arrow",
        "color": "#999",
        "size": "20"
      }
    })], 1)]), _c('div', {
      staticClass: "Content",
      domProps: {
        "innerHTML": _vm._s(item.idcContent)
      }
    })])])]);
  }), 1)], 1), _c('div', {
    staticClass: "centent2"
  }, [_c('p', {
    staticClass: "servertit"
  }, [_vm._v("公司服务")]), _vm._m(2), _vm._l(_vm.yunweis, function (item, index) {
    return _c('div', {
      key: index + '6',
      staticClass: "item",
      staticStyle: {
        "border-bottom": "0.01rem solid #e2e2e2"
      },
      on: {
        "click": _vm.btnyw
      }
    }, [_c('img', {
      staticClass: "image",
      attrs: {
        "src": item.detailImg
      }
    }), _c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "text-title"
    }, [_c('img', {
      staticClass: "text-img",
      attrs: {
        "src": item.img
      }
    }), _c('div', {
      staticClass: "titles"
    }, [_vm._v(_vm._s(item.operatorTitle))])]), _c('div', {
      staticClass: "antistop"
    }, _vm._l(item.keywords, function (item, index) {
      return _c('div', {
        key: index,
        staticClass: "antistop-item"
      }, [_vm._v(_vm._s(item) + " /")]);
    }), 0), _vm._m(3, true)])]);
  }), _vm._l(_vm.jichengs, function (item, index) {
    return _c('div', {
      key: index + '5',
      staticClass: "item",
      staticStyle: {
        "border-bottom": "0.01rem solid #e2e2e2"
      },
      on: {
        "click": _vm.btnjc
      }
    }, [_c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "text-title"
    }, [_c('img', {
      staticClass: "text-img",
      attrs: {
        "src": item.img
      }
    }), _c('div', {
      staticClass: "titles"
    }, [_vm._v(_vm._s(item.isrTitle))])]), _c('div', {
      staticClass: "antistop"
    }, _vm._l(item.keywords, function (item, index) {
      return _c('div', {
        key: index,
        staticClass: "antistop-item"
      }, [_vm._v(_vm._s(item) + " /")]);
    }), 0), _vm._m(4, true)]), _c('img', {
      staticClass: "image",
      attrs: {
        "src": item.detailImg
      }
    })]);
  }), _vm._l(_vm.ruodains, function (item, index) {
    return _c('div', {
      key: index + '4',
      staticClass: "item",
      staticStyle: {
        "border-bottom": "0.01rem solid #e2e2e2"
      },
      on: {
        "click": _vm.btnrd
      }
    }, [_c('img', {
      staticClass: "image",
      attrs: {
        "src": item.detailImg
      }
    }), _c('div', {
      staticClass: "text"
    }, [_c('div', {
      staticClass: "text-title"
    }, [_c('img', {
      staticClass: "text-img",
      attrs: {
        "src": item.img
      }
    }), _c('div', {
      staticClass: "titles"
    }, [_vm._v(_vm._s(item.engineerTitle))])]), _c('div', {
      staticClass: "antistop"
    }, _vm._l(item.keywords, function (item, index) {
      return _c('div', {
        key: index + 1,
        staticClass: "antistop-item"
      }, [_vm._v(_vm._s(item) + " /")]);
    }), 0), _vm._m(5, true)])]);
  })], 2), _c('div', {
    staticClass: "centent3"
  }, [_vm._l(_vm.statistics, function (item, index) {
    return _c('div', {
      key: index + '7',
      staticClass: "item"
    }, [_c('p', {
      staticClass: "p1"
    }, [_vm._v(_vm._s(item.number) + " "), item.companyIsShow ? _c('span', {
      staticClass: "item-myriad"
    }, [_vm._v("万")]) : _vm._e(), item.key == 'companyEstablishedTime' || item.key == 'serviceExperience' ? _c('span', {
      staticClass: "item-year"
    }, [_vm._v("年")]) : _vm._e(), index != 0 ? _c('span', {
      staticClass: "more"
    }, [_vm._v("+")]) : _vm._e()]), _c('div', {
      staticClass: "xian"
    }), _c('p', {
      staticClass: "p2"
    }, [_vm._v(_vm._s(item.text))])]);
  }), _vm._m(6)], 2), _c('div', {
    staticClass: "content5"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("新闻资讯")]), _vm._m(7), _c('div', {
    staticClass: "box-item",
    on: {
      "click": function ($event) {
        return _vm.xinwen(_vm.xinwenlift.id);
      }
    }
  }, [_c('div', {
    staticClass: "item1"
  }, [_c('img', {
    attrs: {
      "src": _vm.xinwenlift.newsImg,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "item2"
  }, [_c('div', {
    staticClass: "item2-title"
  }, [_c('div', {
    staticClass: "item2-title-left"
  }, [_vm._v(_vm._s(_vm.xinwenlift.newsTitle))]), _c('img', {
    staticClass: "item2-title-img",
    attrs: {
      "src": require("../../../assets/mobileimg/Slice 29 (2).png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "item2-content",
    domProps: {
      "innerHTML": _vm._s(_vm.xinwenlift.synopsisContent)
    }
  })])]), _vm._l(_vm.xinwenzixun.slice(1, 3), function (item, index) {
    return _c('div', {
      key: index + '11',
      staticClass: "xiao-item",
      on: {
        "click": function ($event) {
          return _vm.xinwen(item.id);
        }
      }
    }, [_c('div', {
      staticClass: "leftimg"
    }, [_c('img', {
      attrs: {
        "src": item.newsImg,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "newtime"
    }, [_vm._v(_vm._s(item.releaseTime))]), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "right-title"
    }, [_c('div', {
      staticClass: "right-title-left"
    }, [_vm._v(_vm._s(item.newsTitle))]), _c('img', {
      staticClass: "item2-title-img",
      attrs: {
        "src": require("../../../assets/mobileimg/Slice 29 (2).png"),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.synopsisContent)
      }
    })])]);
  }), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.btnxwdt
    }
  }, [_vm._v("查看更多")])], 2), _c('div', {
    staticClass: "content4"
  }, [_c('img', {
    staticClass: "content4-background",
    attrs: {
      "src": _vm.background,
      "alt": ""
    }
  }), _c('div', {
    staticClass: "item-box"
  }, [_c('p', {
    staticClass: "p1"
  }, [_vm._v("设计")]), _vm._m(8), _c('div', {
    staticClass: "item-box-title"
  }, _vm._l(_vm.queryDesign, function (item, index) {
    return _c('div', {
      key: index + '12',
      class: _vm.ids == index ? 'item-box-item2' : 'item-box-item',
      on: {
        "click": function ($event) {
          return _vm.getdesign(index, item, item.backgroundImg);
        }
      }
    }, [_vm._v(" " + _vm._s(item.designTitle) + " ")]);
  }), 0), _c('div', {
    staticClass: "item-box-box"
  }, _vm._l(_vm.queryDesignDetail, function (item, index) {
    return _c('div', {
      key: index + '13',
      staticClass: "item-box-box-item",
      on: {
        "click": function ($event) {
          return _vm.getitem(_vm.queryDesign[_vm.ids], item, index);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _c('div', {
      staticClass: "item-box-box-title"
    }, [_c('div', [_vm._v(_vm._s(item.designTitle))])])]);
  }), 0), _c('div', {
    staticClass: "content4-btn",
    on: {
      "click": _vm.getmore
    }
  }, [_vm._v("查看更多")])])]), _c('div', {
    staticClass: "centent6"
  }, [_c('van-swipe', {
    staticClass: "my-swipe",
    attrs: {
      "autoplay": 3000,
      "indicator-color": "white"
    }
  }, [_c('van-swipe-item', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.cowCooperativePartnerGetInfo.title))]), _c('div', {
    staticClass: "title2",
    domProps: {
      "innerHTML": _vm._s(_vm.cowCooperativePartnerGetInfo.subheading)
    }
  }), _c('div', {
    staticClass: "centent6-content"
  }, [_vm._l(_vm.orn, function (item, index) {
    return _c('div', {
      key: index + '14',
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })]);
  }), _c('div', {
    staticClass: "figure"
  }, [_c('div', {
    staticClass: "figure1"
  }, [_vm._v("合作伙伴案例")]), _c('div', {
    staticClass: "figure2"
  }, [_vm._v(_vm._s(_vm.cowCooperativePartnerGetInfo.friendNum))])]), _vm._l(_vm.orns, function (item, index) {
    return _c('div', {
      key: index + '15',
      staticClass: "item"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    })]);
  }), _c('div', {
    staticClass: "item",
    on: {
      "click": _vm.cooperative
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/mobileimg/Slice 201 (1).png"),
      "alt": ""
    }
  })])], 2)])], 1)], 1)], 2)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "box-center-title"
  }, [_c('div', {
    staticClass: "box-center-title1"
  }, [_c('div', {
    staticClass: "title-xian"
  }), _c('div', {
    staticClass: "title-dian"
  })]), _c('div', {
    staticClass: "box-center-title2"
  }, [_vm._v("一站式的品牌数字服务体系")]), _c('div', {
    staticClass: "box-center-title3"
  }, [_c('div', {
    staticClass: "title-dian"
  }), _c('div', {
    staticClass: "title-xian"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "box-center-title"
  }, [_c('div', {
    staticClass: "box-center-title1"
  }, [_c('div', {
    staticClass: "title-xian"
  }), _c('div', {
    staticClass: "title-dian"
  })]), _c('div', {
    staticClass: "box-center-title2"
  }, [_vm._v("一站式的品牌数字服务体系")]), _c('div', {
    staticClass: "box-center-title3"
  }, [_c('div', {
    staticClass: "title-dian"
  }), _c('div', {
    staticClass: "title-xian"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "box-center-title"
  }, [_c('div', {
    staticClass: "box-center-title1"
  }, [_c('div', {
    staticClass: "title-xian"
  }), _c('div', {
    staticClass: "title-dian"
  })]), _c('div', {
    staticClass: "box-center-title2"
  }, [_vm._v("为您提供专业贴心的服务")]), _c('div', {
    staticClass: "box-center-title3"
  }, [_c('div', {
    staticClass: "title-dian"
  }), _c('div', {
    staticClass: "title-xian"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "btn-box"
  }, [_c('div', {
    staticClass: "btn"
  }, [_vm._v("查看更多")]), _c('div', {
    staticClass: "arrows"
  }), _c('div', {
    staticClass: "arrowss"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "btn-box"
  }, [_c('div', {
    staticClass: "btn"
  }, [_vm._v("查看更多")]), _c('div', {
    staticClass: "arrows"
  }), _c('div', {
    staticClass: "arrowss"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "btn-box"
  }, [_c('div', {
    staticClass: "btn"
  }, [_vm._v("查看更多")]), _c('div', {
    staticClass: "arrows"
  }), _c('div', {
    staticClass: "arrowss"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "centent3-bottom-text"
  }, [_c('div', {
    staticClass: "centent3-bottom-text-item"
  }, [_vm._v("用心，用行动，为客户持续创造价值")]), _c('div', {
    staticClass: "centent3-bottom-text-items"
  }, [_vm._v("致力于成为企业认可的互联网战略合作伙伴")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "box-center-title"
  }, [_c('div', {
    staticClass: "box-center-title1"
  }, [_c('div', {
    staticClass: "title-xian"
  }), _c('div', {
    staticClass: "title-dian"
  })]), _c('div', {
    staticClass: "box-center-title2"
  }, [_vm._v("NEWS AND INFORMATION")]), _c('div', {
    staticClass: "box-center-title3"
  }, [_c('div', {
    staticClass: "title-dian"
  }), _c('div', {
    staticClass: "title-xian"
  })])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "box-center-title"
  }, [_c('div', {
    staticClass: "box-center-title1"
  }, [_c('div', {
    staticClass: "title-xian"
  }), _c('div', {
    staticClass: "title-dian"
  })]), _c('div', {
    staticClass: "box-center-title2",
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("为您提供精美的界面设计")]), _c('div', {
    staticClass: "box-center-title3"
  }, [_c('div', {
    staticClass: "title-dian"
  }), _c('div', {
    staticClass: "title-xian"
  })])]);
}];
export { render, staticRenderFns };